import { useEffect } from "react"
import $ from "jquery"
import { HelmetProvider } from "react-helmet-async"
import AppRouter from "./routes/AppRouter"

// Import all CSS at the app level to prevent FOUC (Flash of Unstyled Content)
import "./assets/vendor/css/bundle.min.css"
import "./assets/vendor/css/wow.css"
import "./assets/vendor/css/LineIcons.min.css"
import "./assets/vendor/css/jquery.fancybox.min.css"
import "./assets/vendor/css/cubeportfolio.min.css"
import "./assets/vendor/css/owl.carousel.min.css"
import "./assets/css/navigation.css"
import "./assets/css/pooja-theme.css"
import "./assets/css/fast-animations.css"
import "./assets/css/hero-fullwidth.css"
import "./assets/css/style.css"
import "./assets/css/services.css"
import "./assets/css/about-page.css"

const App = () => {

  useEffect(() => {
    // Initialize jQuery globally as early as possible
    if (typeof window !== 'undefined') {
      window.$ = window.jQuery = $
      // Trigger a custom event to notify components that jQuery is ready
      window.dispatchEvent(new CustomEvent('jqueryReady'))
    }
  }, [])

  return (
    <HelmetProvider>
      <AppRouter />
    </HelmetProvider>
  )
}

export default App
